import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { InfoComplementField } from '@/components/new-info-complete/types';

@Component({ name: 'DebtSituation' })
export default class DebtSituation extends Vue implements InfoComplementField {
  @Prop()
  private value!: undefined | number;

  private debtSituation: undefined | number | null = null;

  private errorMsg = '';

  private options: OptionItem[] = [];

  private async created() {
    if (this.value) {
      this.debtSituation = this.value;
    }

    this.options = await DictApi.getDebtSituation();
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.debtSituation) {
      this.debtSituation = val;
    }
  }

  public onValidator(): boolean {
    if (this.debtSituation === undefined || this.debtSituation === null) {
      this.errorMsg = '请选择已有负债';
      return false;
    }

    return true;
  }

  private onChangeDebtSituation(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <Field
        label="已有负债"
        errorMessage={this.errorMsg}
        >
        <SelectInput
          v-model={this.debtSituation}
          title="选择已有负债"
          placeholder="选择已有负债"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChangeDebtSituation}
        />
      </Field>
    );
  }
}
